export default "__VITE_ASSET__DBTb0QL5__"